var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"id":"timeframe-filter","items":_vm.timeframes,"clearable":"","loading":_vm.loadingImages,"outlined":"","label":"View Fault Detections Within Timeframe","single-line":""},on:{"input":_vm.filterByTimeframe},model:{value:(_vm.selectedTimeFrame),callback:function ($$v) {_vm.selectedTimeFrame=$$v},expression:"selectedTimeFrame"}})
}
var staticRenderFns = []

export { render, staticRenderFns }